"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultResolver = void 0;
// importing the factory directly, as we feed it our own fs, and don't want graceful-fs to be implicitly imported
// this allows @stylable/core to be bundled for browser usage without special custom configuration
const ResolverFactory = require('enhanced-resolve/lib/ResolverFactory');
const resolverContext = {};
function createDefaultResolver(fileSystem, resolveOptions) {
    const eResolver = ResolverFactory.createResolver({
        useSyncFileSystemCalls: true,
        fileSystem,
        ...resolveOptions,
    });
    return (directoryPath, request) => eResolver.resolveSync(resolverContext, directoryPath, request);
}
exports.createDefaultResolver = createDefaultResolver;
//# sourceMappingURL=module-resolver.js.map